"use client";

import React, { useEffect, useRef } from "react";
import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { useAnimations } from "@react-three/drei";
import { Mesh } from "three";
import { useSpring, animated } from "@react-spring/three";
import { useUIStore } from "@/stores/ui-states.store";

interface Props {
  multiplier: number;
}

const LogoModel: React.FC<Props> = ({ multiplier }) => {
  const { setIsModelLoaded } = useUIStore();

  const meshRef = useRef<Mesh>(null);

  const model = useLoader(GLTFLoader, "/blessnet-logo.glb", undefined);
  const { actions } = useAnimations(model.animations, model.scene);

  const { scale } = useSpring({
    from: {
      scale: 0 * multiplier,
    },
    to: async (next) => {
      await next({ scale: 2 * multiplier });
    },
    config: { tension: 60, friction: 12 },
  });

  useEffect(() => {
    if (actions) {
      setIsModelLoaded(true);
      actions.float?.play();
    }
  }, [actions, setIsModelLoaded]);

  return (
    <animated.mesh ref={meshRef} scale={scale}>
      <primitive object={model.scene} />
    </animated.mesh>
  );
};

export default LogoModel;
